import { parsedUser } from "../../common/GetCurrentUser"
import CRUDField from "../core/genericCRUD/CRUDField"
const user = parsedUser()
const LaborAccessRequestDTO: CRUDField[] = [
  {
    title: "Datos del Propietario/Inquilino de la unidad",
    htmlType: "separator",
    dbType: "string",
    name: "",
  },
  {
    name: "id",
    title: "id",
    htmlType: "hidden",
    dbType: "string",
    required: false,
    groupNumber: 0,
    containerClass: "col-md-6 col-12",
  },

  {
    name: "organizationId",
    title: "organizationId",
    htmlType: "hidden",
    dbType: "string",
    required: false,
    groupNumber: 0,
    containerClass: "col-md-6 col-12",
  },

  {
    name: "propetaryName",
    title: "Nombre y Apellido",
    htmlType: "text",
    dbType: "string",
    required: true,
    containerClass: " col-12 col-md-6",
    groupNumber: 0,
  },
  {
    name: "propetaryEmail",
    title: "Email",
    htmlType: "text",
    dbType: "string",
    required: true,
    containerClass: " col-12 col-md-6",
    groupNumber: 0,
  },
  {
    name: "propetaryPhone",
    title: "Télefono",
    htmlType: "text",
    dbType: "string",
    required: false,
    containerClass: " col-12 col-md-6",
    groupNumber: 0,
  },
  {
    name: "cardnetNo",
    title: "Número de Cardnet",
    htmlType: "text",
    dbType: "string",
    required: true,
    containerClass: " col-12 col-md-6",
    groupNumber: 0,
  },
  {
    title: "Destino Laboral",
    htmlType: "separator",
    dbType: "string",
    name: "",
  },
  {
    name: "typeOfLaborPlaceId",
    title: "Tipo de espacio laboral",
    htmlType: "select",
    dbType: "string",
    required: false,
    containerClass: "col-md-6 col-12",
    groupNumber: 0,

    datasourceMethod: "POST",
    dataSource: "LaborAccessRequestWorkingSpace/list",

    dataSourceTextField: "name",
    dataSourceValueField: "id",
  },
  {
    name: "laborAccessRequestSectorId",
    title: "Sector",
    htmlType: "select",
    dbType: "string",
    required: false,
    containerClass: " col-12 col-md-6",
    groupNumber: 0,

    datasourceMethod: "POST",
    dataSource: "LaborAccessRequestSector/list",

    dataSourceTextField: "name",
    dataSourceValueField: "id",
  },
  {
    name: "startWorkDate",
    title: "Fecha de Inicio del Trabajo",
    htmlType: "datetime",
    dbType: "datetimeoffset",
    required: false,
    containerClass: "col-12 col-md-6 col-lg-4",
    groupNumber: 0,
  },
  {
    name: "endWorkDate",
    title: "Fecha de Conclusión del trabajo",
    htmlType: "datetime",
    dbType: "datetimeoffset",
    required: false,
    containerClass: "col-12 col-md-6 col-lg-4",
    groupNumber: 0,
  },

  {
    name: "visitDuration",
    title: "Tiempo solicitado (días)",
    htmlType: "text",
    dbType: "string",
    required: false,
    containerClass: " col-12 col-md-6 col-lg-4",
    groupNumber: 0,
  },
  {
    name: "address",
    title: "Address",
    htmlType: "searchMap",
    dbType: "string",
    required: false,
    containerClass: " col-12",
    groupNumber: 0,
  },

  {
    name: "latitude",
    title: "Latitude",
    htmlType: "hidden",
    dbType: "string",
    required: false,

    containerClass: "col-md-6 col-12",
    groupNumber: 0,
  },
  {
    name: "longitude",
    title: "Longitude",
    htmlType: "hidden",
    dbType: "string",
    required: false,
    containerClass: "col-md-6 col-12",
    groupNumber: 0,
  },
  {
    name: "locationMap",
    title: "Map",
    htmlType: "map",
    dbType: "string",
    required: false,
    containerClass: " col-12",
    groupNumber: 0,
  },
  {
    title: "Representante Laboral",
    htmlType: "separator",
    dbType: "string",
    name: "",
  },
  {
    name: "rnc",
    title: "RNC",
    htmlType: "searchRNC",
    dbType: "string",
    required: false,
    containerClass: " col-12 col-md-4",
    groupNumber: 0,
  },
  {
    name: "companyName",
    htmlType: "text",
    dbType: "string",
    title: "Company Name",
    containerClass: "col-12 col-md-4",
    required: true,
  },
  {
    name: "typeOfRepresentativeId",
    title: "Tipo de representante",
    htmlType: "select",
    dbType: "string",
    required: false,
    containerClass: "col-md-4 col-12",
    groupNumber: 0,

    dataSourceTextField: "name",
    dataSourceValueField: "id",
    dataSourceLocal: [
      {
        id: "1",
        name: "Contratista",
      },
      {
        id: "3",
        name: "Intermediario",
      },
      {
        id: "2",
        name: "Subcontratista",
      },
      {
        id: "4",
        name: "Suplidor",
      },
      {
        id: "5",
        name: "Proveedor de Servicios",
      },
    ],
  },

  {
    name: "responsableId",
    title: "Cédula de Responsable",
    htmlType: "cedula",
    dbType: "string",
    required: false,
    containerClass: "col-md-6  col-12",
    
  },
  {
    name: "responsableName",
    title: "Nombre de Responsable",
    htmlType: "text",
    dbType: "string",
    required: true,
    containerClass: "col-md-6  col-12",
    groupNumber: 0,
    datasourceMethod: "POST",
    dataSource: "employee/list",
    dependOf: "organizationId",
    dependOfValue: user?.OrganizationId,

    dataSourceTextField: "fullName",
    dataSourceValueField: "employeeId",
  },
  {
    name: "responsablePhone",
    title: "Télefono responsable",
    htmlType: "text",
    dbType: "string",
    required: false,
    containerClass: " col-12 col-md-6 ",
    groupNumber: 0,
  },{
    name: "responsableEmail",
    title: "Correo responsable",
    htmlType: "text",
    dbType: "string", readOnly: true,
    required: false,
    containerClass: " col-12 col-md-6 ",
    groupNumber: 0,
  },
  
  {
    name: "secondResponsableId",
    title: "Cédula de 2do. Responsable",
    htmlType: "cedula",
    dbType: "string",
    required: false,
    containerClass: "col-md-6  col-12",
    
  },
  {
    name: "secondResponsableName",
    title: "Nombre 2do. Responsable",
    htmlType: "text",
    dbType: "string",
    required: false,
    containerClass: "col-md-6  col-12",
    
  },
  {
    name: "secondResponsablePhone",
    title: "Télefono 2do. responsable",
    htmlType: "text",
    dbType: "string",
    required: false,
    containerClass: " col-12 col-md-6 ",
    groupNumber: 0,
  },
  {
    name: "secondResponsableEmail",
    title: "Correo 2do. responsable",
    htmlType: "text",
    dbType: "string", readOnly: true,
    required: false,
    containerClass: " col-12 col-md-6 ",
    groupNumber: 0,
  },
]

export default LaborAccessRequestDTO
